<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    labels: Array,
    data: Array,
    backgroundColor: Array
  },
  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.backgroundColor,
          data: this.data
        }
      ]
    }, {responsive: true, maintainAspectRatio: true})
  },
  watch: {
    data: function () {
      // this._chart.destroy();
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.backgroundColor,
            data: this.data
          }
        ]
      }, {responsive: true, maintainAspectRatio: true})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/PieExample.vue